import styled from 'styled-components';

import {
  colorGray900,
  colorGrey200,
  colorPrimary50,
  colorPrimary400,
  colorWhite,
  fontFamilyPrimary,
} from '@/styleUtils';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  svg {
    display: none;
  }

  &[data-is-checked='true'] {
    div:first-of-type {
      background: ${colorPrimary400};
      border: none;
    }

    svg {
      width: 16px;
      height: 16px;
      padding: 3px 0 0 4px;
      display: block;
    }
  }
`;

export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${colorGrey200};
  border-radius: 2px;
  flex-shrink: 0;
  color: ${colorWhite};
`;

export const Label = styled.span`
  cursor: pointer;
  display: block;
  font: normal 400 16px/28px ${fontFamilyPrimary};
  color: ${colorGray900};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  input:checked + & {
    background-color: ${colorPrimary50};
    position: relative;

    &::after {
      content: '';
      position: absolute;
      display: block;
      height: 9px;
      right: 16px;
      top: 50%;
      transform: rotate(45deg) translateY(-50%);
      transform-origin: right center;
      width: 5px;
      border-color: rgb(35, 156, 19);
      border-style: solid;
      border-width: 0 2px 2px 0;
    }
  }
`;
